import { Typography } from '@mui/material';
import { NotificationRole } from '@provision/entity-types';
import { SelectMenu, type SelectMenuOption } from 'src/components/SelectMenu';
import { NotificationRoleResponse } from 'src/graphql/entities/notification-preference';

export type NotificationRoleSelectProps = {
  roleOptions: NotificationRole[];
  selectedValues: NotificationRoleResponse[];
  onChange: (nextValues: NotificationRoleResponse[]) => void;
};

export const NotificationRoleSelect = ({
  roleOptions,
  selectedValues,
  onChange,
}: NotificationRoleSelectProps) => {
  if (!roleOptions.length) {
    return <Typography variant="body2">Always</Typography>;
  }

  const options: SelectMenuOption[] = roleOptions.map((role) => ({
    value: role.id,
    title: role.name,
  }));

  return (
    <SelectMenu
      label="Notify when"
      multiple
      options={options}
      values={selectedValues.map((role) => role.id)}
      onValuesChange={(nextIds) =>
        onChange(roleOptions.filter((role) => nextIds.includes(role.id)))
      }
      placeholder="Never"
      triggerContent={
        selectedValues.length ? selectedValues.map((role) => role.name).join(', ') : undefined
      }
      menuWidth="trigger"
      sx={{ width: '100%' }}
    />
  );
};
